import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

const STEPS = [
  { step: 1, title: "Initial Discovery Call", subtitle: "Qualification & Vision Alignment", description: "A 30-minute introductory session to discuss your background, business goals, target market availability, and financial qualifications." },
  { step: 2, title: "Executive Review & FDD Deep Dive", subtitle: "Unit Economics & Financial Disclosures", description: "A thorough examination of our Franchise Disclosure Document (FDD), unit performance, operational playbooks, and revenue model." },
  { step: 3, title: "Discovery Day in Phoenix", subtitle: "Executive Leadership Meet & Tour", description: "Visit Dogtopia headquarters, meet executive leadership, tour flagship daycare centers, and experience our proprietary tech platform." },
  { step: 4, title: "Franchise Award & Site Selection", subtitle: "Real Estate & Lease Negotiations", description: "Sign your franchise agreement and pair with our dedicated real estate team to identify optimal high-traffic, demographic-rich locations." },
  { step: 5, title: "University Training & Grand Opening", subtitle: "6-Week Intensive Launch Program", description: "Complete 6 weeks of Dogtopia University hands-on training covering management, safety protocols, marketing setup, and grand opening execution." },
];

export function Process() {
  return (
    <section id="process" className="py-20 md:py-28" data-testid="process-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <Reveal>
              <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#FF6B4A] mb-4">The Process</p>
              <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#0D3B3E]">
                From first call to grand opening in five steps
              </h2>
              <p className="mt-5 text-[#5C6B6C] leading-relaxed max-w-md">
                A guided, transparent path with a dedicated franchise development team beside you at every milestone —
                typically 9 to 12 months from signing to opening day.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-7 relative">
          <div className="absolute left-[27px] top-2 bottom-2 w-px bg-[#E4DFD3]" />
          <div className="space-y-10">
            {STEPS.map((s, i) => (
              <motion.div
                key={s.step}
                initial={{ opacity: 0, x: 32 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6, delay: 0.05 * i, ease: [0.22, 1, 0.36, 1] }}
                className="relative pl-20"
                data-testid={`process-step-${s.step}`}
              >
                <div className="absolute left-0 top-0 w-14 h-14 rounded-2xl bg-white border border-[#E4DFD3] flex items-center justify-center shadow-sm">
                  <span className="font-display font-extrabold text-[#FF6B4A] text-lg">{s.step}</span>
                </div>
                <div className="bg-white rounded-3xl border border-[#E4DFD3] p-7 hover:shadow-lg transition-shadow">
                  <div className="text-[11px] uppercase tracking-[0.2em] text-[#5C6B6C] font-semibold mb-1">{s.subtitle}</div>
                  <h3 className="font-display text-xl font-semibold text-[#0D3B3E] mb-2">{s.title}</h3>
                  <p className="text-sm text-[#5C6B6C] leading-relaxed">{s.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
